import { render, staticRenderFns } from "./AppLocalization.vue?vue&type=template&id=191056ee&"
import script from "./AppLocalization.vue?vue&type=script&lang=js&"
export * from "./AppLocalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('191056ee')) {
      api.createRecord('191056ee', component.options)
    } else {
      api.reload('191056ee', component.options)
    }
    module.hot.accept("./AppLocalization.vue?vue&type=template&id=191056ee&", function () {
      api.rerender('191056ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/widget/AppLocalization.vue"
export default component.exports